var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ArrayUtils } from '@everyboard/lib';
import { MoveGenerator } from '../../jscaip/AI/AI';
import { Debug } from '../../utils/Debug';
let TaflMoveGenerator = class TaflMoveGenerator extends MoveGenerator {
    rules;
    constructor(rules) {
        super();
        this.rules = rules;
    }
    getListMoves(node, config) {
        const state = node.gameState;
        const currentPlayer = state.getCurrentPlayer();
        const listMoves = this.rules.getPlayerListMoves(currentPlayer, state, config);
        return this.orderMoves(state, listMoves, config);
    }
    orderMoves(state, listMoves, config) {
        const king = this.rules.getKingCoord(state).get();
        const invader = this.rules.getInvader(config);
        if (state.getCurrentPlayer() === invader) { // Invader
            ArrayUtils.sortByDescending(listMoves, (move) => {
                return -move.getEnd().getOrthogonalDistance(king);
            });
        }
        else {
            ArrayUtils.sortByDescending(listMoves, (move) => {
                if (move.getStart().equals(king)) {
                    if (state.isExternalThrone(move.getEnd())) {
                        return 2;
                    }
                    else {
                        return 1;
                    }
                }
                else {
                    return 0;
                }
            });
        }
        return listMoves;
    }
};
TaflMoveGenerator = __decorate([
    Debug.log
], TaflMoveGenerator);
export { TaflMoveGenerator };
